/* stylelint-disable selector-max-compound-selectors */
:host {
  @include reset-host;
}

:host .sharing-modal {
  @include cover;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @include mq('max', 'md') {
    justify-content: flex-end;
  }

  .backdrop {
    @include cover;

    display: block;

    background: rgba($black, 0.4);
    backdrop-filter: blur(2px);
  }

  .wrapper {
    position: relative;

    width: 100%;
    max-width: rem(500);
    padding: rem(40);

    background: $white;
    border-radius: $radius-lg;
    transform-style: preserve-3d; // to put child (snackbar) behind parent

    @include mq('max', 'md') {
      width: 100%;
      max-width: unset;
      padding: rem(40) $gutter-mobile;

      border-bottom-right-radius: 0;

      border-bottom-left-radius: 0;
    }
  }

  .content {
    position: relative;
  }

  .title {
    margin-bottom: rem(40);
    padding-right: rem(80);

    font-size: $fs-3xl;
    line-height: 1.2;
  }

  .snackbar-wrapper {
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    justify-content: center;
    width: 100%;

    transform: translateZ(-1px); // negative translateZ to put child behind parent

    opacity: 0;

    transition: $transition-smooth;
    transition-property: transform, opacity;

    &.is-visible {
      transform: translateY(calc(-100% - #{rem(20)})) translateZ(-1px);
      opacity: 1;
    }
  }

  .snackbar {
    display: flex;
    align-items: center;
    height: rem(26);
    padding: 0 1em;

    color: $white;
    font-size: $fs-sm;

    background: rgb(78, 149, 78);
    border-radius: rem(20);
  }

  .snackbar-icon {
    margin-right: rem(8);

    color: inherit;

    efb-icon {
      font-size: rem(14);
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;

    list-style: none;

    efb-button {
      width: 100%;
    }
  }

  .button-group-item + .button-group-item {
    margin-top: rem(10);
  }
}

:host::part(sharing-close-button) {
  position: absolute;
  top: 0;
  right: 0;
}
